import React from 'react'
import {Button} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'
import QuantityPicker from '../../../components/quantity-picker'

const FreeItemPromoActionButton = ({qty, allowedItems, totalQuantity, productName, onChange}) => {
    const hideQtyPicker = qty === 0 && totalQuantity >= allowedItems

    // Show outline Add button only when qty is 0
    if (qty === 0) {
        return (
            <Button
                variant="outline-not-rounded"
                size="large"
                isDisabled={hideQtyPicker}
                onClick={() => onChange(1)} // delta of +1 to go from 0 to 1
            >
                <FormattedMessage
                    id="cart.free_item_promo_drawer.add_button"
                    defaultMessage="Add"
                />
            </Button>
        )
    }

    // Show QuantityPicker when qty >= 1
    // Minus button works on qty >= 2
    // Delete icon appears when qty = 1 and reverts to Add button (qty becomes 0)
    return (
        <QuantityPicker
            value={qty}
            min={1}
            max={qty + (allowedItems - totalQuantity)}
            step={1}
            onChange={(_str, num) => {
                const delta = num - qty
                if (delta !== 0) {
                    onChange(delta)
                }
            }}
            productName={productName}
            variant="freeItemPromo"
        />
    )
}

FreeItemPromoActionButton.propTypes = {
    qty: PropTypes.number,
    allowedItems: PropTypes.number,
    totalQuantity: PropTypes.number,
    productName: PropTypes.string,
    onChange: PropTypes.func,
}

export default FreeItemPromoActionButton
